/*eslint-disable*/ export const messages = JSON.parse("{\"checkbox-group.label.optional\":[\"Valinnainen\"],\"checkbox-group.validation.required\":[\"Vähintään yksi valinta vaaditaan.\"]}");
//# sourceMappingURL=messages.mjs.map